/**
 * discontinued-popup.js
 * Handles behaviour for the discontinued product popup overlay.
 * Upload to: Shopify Admin → Online Store → Themes → Edit Code → Assets
 */
(function () {
  'use strict';

  const STORAGE_KEY_PREFIX = 'disc_popup_dismissed_';

  function getProductHandle() {
    // Shopify exposes window.meta.product.handle on product pages
    if (window.meta && window.meta.product && window.meta.product.handle) {
      return window.meta.product.handle;
    }
    // Fallback: parse from URL path /products/handle
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getStorageKey(handle) {
    return STORAGE_KEY_PREFIX + handle;
  }

  function wasDismissed(handle) {
    try {
      const val = sessionStorage.getItem(getStorageKey(handle));
      return val === '1';
    } catch (_) {
      return false;
    }
  }

  function markDismissed(handle) {
    try {
      sessionStorage.setItem(getStorageKey(handle), '1');
    } catch (_) {
      // sessionStorage blocked - silently continue
    }
  }

  function dismissPopup(overlay, handle) {
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.2s ease';
    setTimeout(function () {
      overlay.style.display = 'none';
    }, 200);
    markDismissed(handle);
  }

  function init() {
    var overlay = document.getElementById('disc-popup-overlay');
    if (!overlay) return; // popup snippet not rendered (product not discontinued)

    var handle = getProductHandle();

    // If user already dismissed this session, hide immediately without animation
    if (handle && wasDismissed(handle)) {
      overlay.style.display = 'none';
      return;
    }

    // Dismiss button - "Continue viewing this page"
    var dismissBtn = document.getElementById('disc-popup-dismiss');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        dismissPopup(overlay, handle);
      });
    }

    // Clicking the dark overlay backdrop (not the modal itself) also dismisses
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        dismissPopup(overlay, handle);
      }
    });

    // Escape key dismisses
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.style.display !== 'none') {
        dismissPopup(overlay, handle);
      }
    });

    // Trap focus inside modal for accessibility
    var modal = overlay.querySelector('.disc-popup-modal');
    if (modal) {
      trapFocus(modal);
      // Move focus into the modal on load
      var firstFocusable = modal.querySelector('a, button, [tabindex]');
      if (firstFocusable) {
        setTimeout(function () { firstFocusable.focus(); }, 300);
      }
    }
  }

  function trapFocus(modal) {
    var focusableSelectors = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;

      var focusables = Array.from(modal.querySelectorAll(focusableSelectors));
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
